<template>
  <v-dialog
    v-model="open"
    max-width="500"
    :persistent="persistent"
    :class="[customClass]"
  >
    <v-card>
      <v-card-title v-show="isHeadingEnabled" class="headline py-1">
        {{ heading }}
      </v-card-title>
      <v-divider class="my-0" />
      <v-card-text class="dialoag-message">
        {{ message }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="dialog-btn"
          :color="cancelColor"
          flat
          @click="$emit('onCancel')"
          :loading="loading"
        >
          {{ cancelText }}
        </v-btn>
        <v-btn
          class="dialog-btn"
          :color="confirmColor"
          flat
          @click="$emit('onConfirm')"
          :loading="loading"
        >
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  VDialog,
  VCard,
  VCardTitle,
  VCardText,
  VCardActions,
  VSpacer,
  VBtn,
  VDivider
} from 'vuetify/lib';
export default {
  props: {
    heading: {
      type: String,
      default: ''
    },
    isHeadingEnabled: {
      type: Boolean,
      default: true
    },
    message: {
      type: String,
      required: true
    },
    confirmColor: {
      type: String,
      default: 'primary'
    },
    cancelColor: {
      type: String,
      default: 'error'
    },
    cancelText: {
      default: 'Cancel'
    },
    confirmText: {
      default: 'Ok'
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    persistent: {
      type: Boolean,
      required: false,
      default: false
    },
    customClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      open: false
    };
  },
  methods: {
    openDialog() {
      this.open = true;
    },
    close() {
      this.open = false;
    }
  },
  components: {
    VDialog,
    VCard,
    VCardTitle,
    VCardText,
    VCardActions,
    VSpacer,
    VBtn,
    VDivider
  }
};
</script>
<style scoped>
.dialoag-message{
  font-size: 16px;
  font-weight: 400;
}
.dialog-btn{
  font-size: 15px;
  font-weight: 500;
}
</style>
